<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="jurisdictionName"
      [canGoBack]="true"
      [noBow]="true" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper [class]="isRightSideContent ? 'right-side-scroll-enabled' : ''">
    @if (loaded) {
      <tidy-card>
        <tidy-row>
          <tidy-text
            [body]="'Agency'" />
        </tidy-row>
        @if (agency) {
          <tidy-row class="vertical-align-center">
            <tidy-image
              [src]="'assets/svg/business-outline.svg'"
              class="body-size" />
            <tidy-text
              [helper]="agency"
              [translate]="false" />
          </tidy-row>
        }
        @if (portalUrl) {
          <tidy-row class="vertical-align-center">
            <tidy-image
              [src]="'assets/svg/globe-outline.svg'"
              class="body-size" />
            <tidy-text
              [helper]="portalUrl"
              [translate]="false" />
          </tidy-row>
        }
        @if (filingMethod) {
          <tidy-row class="vertical-align-center">
            <tidy-image
              [src]="'assets/svg/document-text-outline.svg'"
              class="body-size" />
            <tidy-text
              [helper]="filingMethod"
              [translate]="false" />
          </tidy-row>
        }
      </tidy-card>

      @if (registrationSteps.length > 0) {
        <tidy-card>
          <tidy-row>
            <tidy-text
              [header]="'How to Register'" />
          </tidy-row>
          @for (step of registrationSteps; track $index) {
            <tidy-row>
              <tidy-text
                [helper]="step"
                [translate]="false" />
            </tidy-row>
          }
        </tidy-card>
      }

      <tidy-card>
        <tidy-row>
          <tidy-text
            [header]="'Taxes in this Jurisdiction'" />
        </tidy-row>
        @for (tax of taxes; track tax.id; let isLast = $last) {
          <tidy-row class="extra-top-padding">
            <tidy-text
              [body]="tax.name"
              [translate]="false" />
          </tidy-row>
          @if (tax.calcLine) {
            <tidy-row>
              <tidy-text
                [helper]="tax.calcLine"
                [translate]="false" />
            </tidy-row>
          }
          @if (tax.formLine) {
            <tidy-row>
              <tidy-text
                [helper]="tax.formLine"
                [translate]="false" />
            </tidy-row>
          }
          @if (tax.marketplaceNote) {
            <tidy-row class="vertical-align-center">
              <tidy-image
                [src]="'assets/svg/information-circle-outline.svg'"
                class="body-size" />
              <tidy-text
                [helper]="tax.marketplaceNote"
                [translate]="false" />
            </tidy-row>
          }
        }
      </tidy-card>
    }
  </tidy-wrapper>
</ng-template>

@if (!isRightSideContent) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (isRightSideContent) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
